import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle(({ theme }) => {
  const { color, type } = theme;

  return `
    html {
      font-size: 100%;
      box-sizing: border-box;

      &.scrollLock {
        height: 100vh;
        overflow: hidden;

        body {
          height: 100vh;
          overflow: hidden;
        }
      }
    }

    *, *:before, *:after {
      box-sizing: inherit;
    }

    body {
      margin: 0;
      padding: 0;
      font-family: ${type.face};
      font-size: ${type.size.regular};
      color: ${color.grayscale[0]};
      background-color: ${color.grayscale[900]} !important; // Remove when not using index.css
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: ${type.weight.bold};
    }

    h1 {
      font-size: ${type.size.huge};
    }

    h2 {
      font-size: ${type.size.larger};
    }

    h3 {
      font-size: ${type.size.large};
    }

    h4 {
      font-size: ${type.size.regular};
    }

    h5 {
      font-size: ${type.size.small};
    }

    h6 {
      font-size: ${type.size.atomic};
    }
  `;
});

export default GlobalStyles;
